
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { setToken } from '@/utils/storage'

export default {
components: {
XInput,
XButton,
Group,
Toast
},
data () {
return {
disable: false,
showToast: false,
message: '',
username: '',
password: ''
}
},
methods: {
doLogin () {
this.disable = true
const username = this.username
const password = this.password
this.$store.dispatch('Login', { username, password }).then((res) => {
const status = res.status
if (status > 0) {
setToken(res.data.token)
this.$router.push({path: '/user/index'})
} else {
this.disable = false
this.message = res.msg
this.showToast = true
}
}).catch((err) => {
this.disable = false
this.message = err.message
this.showToast = true
})




},

goRedirect () {
this.$router.push({path: '/login/reset'})
}
}
}



// WEBPACK FOOTER //
// ./src/components/login/Login.vue